import React from "react";
import { Box, Grid } from "@mui/material";
import Heading from "../../components/Heading";
import { getMeaning } from "../../utils/localization";
import BlogCards from "../../components/Blog/BlogCards";
import { ReImagineStyles } from "../../components/Styles";
import GlobalSubHeading from "../../components/GlobalSubHeading";
import BlogHeroCardOne from "../../components/BlogHero/BlogHeroCardOne";

const BLOGSLIST = [
  {
    id: 0,
    blogTitle: getMeaning("BLOGS.GCIHDNG"),
    blogImage: require("../../assets/images/Home/BlogOne.jpg"),
    blogHeading: getMeaning("BLOGS.GCILBL"),
    blogDescription: getMeaning("BLOGS.GCIDSCRPTN"),
    blogCreatedDate: getMeaning("BLOGS.GCICREATEDON"),
  },
  {
    id: 1,
    blogTitle: getMeaning("BLOGS.ASTNC/ASCHDNG"),
    blogImage: require("../../assets/images/Home/BlogTwo.jpg"),
    blogHeading: getMeaning("BLOGS.ASTNC/ASCLBL"),
    blogDescription: getMeaning("BLOGS.ASTNC/ASCDSCRPTN"),
    blogCreatedDate: getMeaning("BLOGS.ASTNC/ASCCREATEDON"),
  },
  {
    id: 2,
    blogTitle: getMeaning("BLOGS.VASHDNG"),
    blogImage: require("../../assets/images/Home/BlogThree.png"),
    blogHeading: getMeaning("BLOGS.VASLBL"),
    blogDescription: getMeaning("BLOGS.VASDSCRPTN"),
    blogCreatedDate: getMeaning("BLOGS.VASCREATEDON"),
  },
  {
    id: 3,
    blogTitle: getMeaning("BLOGS.ASSTNCSRVCHDNG"),
    blogImage: require("../../assets/images/Home/BlogFour.png"),
    blogHeading: getMeaning("BLOGS.ASSTNCSRVCLBL"),
    blogDescription: getMeaning("BLOGS.ASSTNCSRVCDSCRPTN"),
    blogCreatedDate: getMeaning("BLOGS.ASSTNCSRVCCREATEDON"),
  },
];

const Blogs = () => {
  return (
    <Box style={{ flex: 1, marginTop: 100 }}>
      <Box>
        <BlogHeroCardOne />
      </Box>

      <Box sx={[ReImagineStyles.rootTwo]}>
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <Box
            sx={{
              width: 2.5,
              height: { xs: 50, md: 70 },
              background: "linear-gradient(45deg, #cfd8dc, #cfd8dc)",
            }}
          />
        </Box>

        <Box align="center">
          <GlobalSubHeading subTitle={getMeaning("BLOGS.DSCRPTN")} />
          {/* <Typography
            sx={[
              HomeBannerStyles.bannerDescription,
              { textAlign: "justify", width: { xs: "100%", md: "80%" } },
            ]}
          >
            {getMeaning("BLOGS.DSCRPTN")}
          </Typography> */}
        </Box>

        <Box mb={2} sx={{ display: "flex", justifyContent: "center" }}>
          <Box
            sx={{
              width: 2.5,
              height: { xs: 50, md: 70 },
              background: "linear-gradient(45deg, #cfd8dc, #cfd8dc)",
            }}
          />
        </Box>

        <Heading title={getMeaning("BLOGS.EXPLRFTRCNTNT")} />

        {/* <Box sx={FastestGrowingStyles.TitleTxtContainer}>
          <Typography sx={HomeBannerStyles.bannerTitle}>
            {getMeaning("BLOGS.EXPLRFTRCNTNT")}
          </Typography>
        </Box> */}

        <Box>
          <Grid
            container
            spacing={3}
            display="flex"
            flexDirection="row"
            justifyContent="center"
            sx={{ marginTop: 4, marginBottom: 4 }}
          >
            {BLOGSLIST?.map((item, index) => {
              return (
                <Grid item key={index} xs={12} sm={6} md={4} lg={4} xl={3}>
                  <BlogCards
                    blogId={item?.id}
                    blogTitle={item?.blogTitle}
                    blogImage={item?.blogImage}
                    blogHeading={item?.blogHeading}
                    blogDescription={item?.blogDescription}
                    blogCreatedDate={item?.blogCreatedDate}
                  />
                </Grid>
              );
            })}
          </Grid>
        </Box>
      </Box>

      {/* <Box style={{ marginBottom: "30px" }}>
        <LeadingConversation />
      </Box> */}
    </Box>
  );
};

export default Blogs;
